export const PC_REGEX_HTTPS_URL =
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;

export const PC_REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PC_REGEX_PHONE = /^\+?(?:[0-9] ?){6,14}[0-9]$/;

export const PC_REGEX_TAG = /[^a-z0-9äöüß\s\-\%\(\u20AC)\+\#\&\:]/i;
